import {
  IGetArbitrationMetadataResponse,
  IGetArbitrationInfoResponse,
  IArbitrationInformationRequest,
  IArbitrationDocumentRequest,
  IArbitrationResult
} from '../types/arbitrationTypes'
import { IBaseResponse } from 'types/baseTypes'
import { fetchAsync, postAsync, apiRootPath } from 'common/fetch'

export const getArbitrationMetadata = async (): Promise<IGetArbitrationMetadataResponse> => {
  const response = await fetchAsync<IBaseResponse<IGetArbitrationMetadataResponse>>(
    `${apiRootPath}/account/arbitration/metadata`
  )
  return response.Value
}

export const getArbitrationInfo = async (vehicleInstanceID: number): Promise<IGetArbitrationInfoResponse> => {
  const response = await fetchAsync<IBaseResponse<IGetArbitrationInfoResponse>>(
    `${apiRootPath}/account/arbitration?vehicleInstanceID=${vehicleInstanceID}`
  )
  return response.Value
}

export const submitArbitration = async (
  request: IArbitrationInformationRequest
): Promise<IBaseResponse<IArbitrationResult>> => {
  return postAsync<IBaseResponse<IArbitrationResult>, IArbitrationInformationRequest>(
    `${apiRootPath}/account/arbitration`,
    { body: request }
  )
}

export const addArbitrationDocuments = async (request: IArbitrationDocumentRequest): Promise<IBaseResponse<string>> => {
  return postAsync<IBaseResponse<string>, IArbitrationDocumentRequest>(
    `${apiRootPath}/account/arbitration/attachments`,
    { body: request }
  )
}
